// src/lib/dealsSlider.js
import {
  collection,
  query,
  where,
  orderBy,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  serverTimestamp,
} from 'firebase/firestore'
import { db } from '../firebase'

// Nom de collection Firestore
const COLL = 'deals_slides'

// Typage léger (optionnel mais utile en dev)
export function normalizeSlide(raw, id) {
  if (!raw) return null
  return {
    id,
    title: raw.title || '',
    subtitle: raw.subtitle || '',
    kicker: raw.kicker || '',
    badge: raw.badge || '',
    ctaLabel: raw.ctaLabel || '',
    ctaHref: raw.ctaHref || '',
    leftImg: raw.leftImg || '',
    leftAlt: raw.leftAlt || '',
    rightImg: raw.rightImg || '',
    rightAlt: raw.rightAlt || '',
    bgColor: raw.bgColor || '#002b7f',
    order: Number(raw.order || 0),
    isActive: !!raw.isActive,
    createdAt: raw.createdAt || null,
    updatedAt: raw.updatedAt || null,
  }
}

/**
 * 🔹 Slides actifs pour la Home
 */
export async function fetchActiveDealsSlides() {
  const qRef = query(
    collection(db, COLL),
    where('isActive', '==', true),
    orderBy('order', 'asc')
  )

  const snap = await getDocs(qRef)
  return snap.docs.map((d) => normalizeSlide(d.data(), d.id))
}

/**
 * 🔹 Tous les slides pour l’admin
 */
export async function fetchAllDealsSlides() {
  const qRef = query(
    collection(db, COLL),
    orderBy('order', 'asc')
  )
  const snap = await getDocs(qRef)
  return snap.docs.map((d) => normalizeSlide(d.data(), d.id))
}

/**
 * 🔹 Création
 */
export async function createDealsSlide(payload) {
  const ref = await addDoc(collection(db, COLL), {
    ...payload,
    order: Number(payload.order || 0),
    isActive: !!payload.isActive,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  })
  return ref.id
}

/**
 * 🔹 Mise à jour
 */
export async function updateDealsSlide(id, payload) {
  const ref = doc(db, COLL, id)
  await updateDoc(ref, {
    ...payload,
    order: Number(payload.order || 0),
    isActive: !!payload.isActive,
    updatedAt: serverTimestamp(),
  })
}

/**
 * 🔹 Suppression
 */
export async function deleteDealsSlide(id) {
  const ref = doc(db, COLL, id)
  await deleteDoc(ref)
}
